import { useDialog, useLocalizeMessage, useToastNotification } from 'libs.nucleus';
export const useSiteUserRemovalConfirmation = () => {
    const translate = useLocalizeMessage();
    const dialog = useDialog();
    const { addNotification } = useToastNotification();
    const confirmSiteUserRemoval = async () => {
        return await dialog.open({
            title: translate('Remove site user'),
            body: translate('This will remove this user from this study site. To restore access, you will need to add them to the study site again.'),
            actionButtons: [{ label: translate('Remove') }, { label: translate('Cancel') }],
        });
    };
    const notifySuccessfulSiteUserRemoval = () => {
        addNotification({
            type: 'success',
            title: translate('User has successfully been removed from the study site.'),
        });
    };
    return {
        confirmSiteUserRemoval,
        notifySuccessfulSiteUserRemoval,
    };
};
